export default class SearchBuilder {

    constructor() {
        this.request = {
            page: {
                limit: 30,
                current: 1
            }
        }
    }


    addPage(current, limit) {
        this.request.page.current = current;
        this.request.page.limit = limit;

    }

    addAttributes(attributes) {
        for(let attribute of attributes) {
            if (attribute.values.length > 0) {
                this.addAttribute(attribute.name, attribute.values);
            }
        }
    }

    addSort(sort) {
        if (sort == 'priceAsc') {
            this.setSortByPriceAsc();
        } else if(sort == 'priceDesc') {
            this.setSortByPriceDesc()
        } else if(sort == 'nameAsc') {
            this.setSortByNameAsc();
        } else if(sort == 'nameDesc'){
            this.setSortByNameDesc();
        } else if(sort == 'quantityAsc'){
            this.setSortByQuantityAsc();
        } else if(sort == 'quantityDesc') {
            this.setSortByQuantityDesc();
        } else {
            this.setSortPriority();
        }
    }

    addActiveProducers() {
        var condition = {
            field: 'Producer.Active',
            value: 'y'
        };
        this.addToCondition(condition, 'conditionTermList');
    }

    addProducers(producers) {
        if (producers.length > 0) {
            var condition = {
                field: 'Producer.Id',
                value: producers
            };
            this.addToCondition(condition, 'conditionArrayList');
        }
    }

    addProductIds(ids) {
        var condition = {
            field: 'Id',
            value: ids
        };
        this.addToCondition(condition, 'conditionArrayList');
    }

    addProductId(id) {
        var conditionTerm = {
            field: 'Id',
            value: id
        };
        this.addToCondition(conditionTerm, 'conditionTermList');
    }

    addNewness() {
        var d = new Date();
        d.setDate(d.getDate()-30);


        var conditionRange = {
            field: 'Added',
            eqFrom: true,
            from:  d.getTime()
        };
        this.addToCondition(conditionRange, 'conditionRangeList');
    }

    addPrice(shopId, from, to) {
        if (from <= 0 && to <= 0) {
            return;
        }
        if (from <= 0) {
            from = 0.01;
        }

        var condition = {
            field: 'ProductPriceList',
            conditionTermList: [{
                field: 'ProductPriceList.Shop',
                value: shopId
            }],
            conditionRangeList: [{
                field: 'ProductPriceList.Price',
                EqFrom: true,
                EqTO: true,
                from: from >= 0 ? from : null,
                to: to >= 0 ? to : null
            }]
        };
        if (this.request.nestedConditionList === undefined) {
            this.request.nestedConditionList = [];
        }
        this.request.nestedConditionList.push(condition);
    }

    addCategoryIds(ids) {
        if (ids.length > 0) {

            var condition = {
                field: 'CategoryList',
                conditionArrayList: [
                    {
                        field: 'CategoryList.Id',
                        value: ids
                    }
                ]
            };

            if (this.request.nestedConditionList === undefined) {
                this.request.nestedConditionList = [];
            }
            this.request.nestedConditionList.push(condition);
        }
    }

    addMainPage() {
        var condition = {
            field: 'SettingValueList',
            conditionTermList: [
                {
                    field: 'SettingValueList.Setting.Name',
                    value: 'STRONA GŁÓWNA'
                },
                {
                    field: 'SettingValueList.Value',
                    value: 'Y'
                }
            ]
        };
        if (this.request.nestedConditionList === undefined) {
            this.request.nestedConditionList = [];
        }
        this.request.nestedConditionList.push(condition);
    }

    addGroupName(groupName) {
        var condition = {
            field: 'SettingValueList',
            conditionTermList: [
                {
                    field: 'SettingValueList.Setting.Name',
                    value: groupName
                },
                {
                    field: 'SettingValueList.Value',
                    value: 'Y'
                }
            ]
        };
        if (this.request.nestedConditionList === undefined) {
            this.request.nestedConditionList = [];
        }
        this.request.nestedConditionList.push(condition);
    }

    addOnlyAvailableProducts() {
        var condition = {
            field: 'VariantList.StockList',
            conditionRangeList: [
                {
                    field: 'VariantList.StockList.Quantity',
                    from: 0,
                    eqFrom: false
                },
            ]
        };
        var conditionPrice = {
            field: 'VariantList',
            conditionRangeList: [
                {
                    field: 'VariantList.IphPriceList.Price',
                    from: 0,
                    eqFrom: false
                },
            ]
        };
        if (this.request.nestedConditionList === undefined) {
            this.request.nestedConditionList = [];
        }
        this.request.nestedConditionList.push(condition);
        this.request.nestedConditionList.push(conditionPrice);
    }

    addMinQuantity(minValue) {
        var condition = {
            field: 'VariantList.StockList',
            conditionRangeList: [
                {
                    field: 'VariantList.StockList.Quantity',
                    from: minValue,
                    eqFrom: true
                },
            ]
        };
        if (this.request.nestedConditionList === undefined) {
            this.request.nestedConditionList = [];
        }
        this.request.nestedConditionList.push(condition);
    }

    addAttribute(field, values) {
        var condition = {
            field: 'VariantList',
            nestedConditionList: [
                {
                    field: 'VariantList.AttributeList',
                    conditionArrayList: [
                        {
                            'field': 'VariantList.AttributeList.Value',
                            'value': values
                        }
                    ],
                    conditionTermList: [
                        {
                            'field': 'VariantList.AttributeList.AttributeProperty.Name',
                            'value': field
                        }
                    ],
                }
            ]
        };

        if (this.request.nestedConditionList === undefined) {
            this.request.nestedConditionList = [];
        }
        this.request.nestedConditionList.push(condition);
    }

    addAssignment(value) {
        var condition = {
            field: 'VariantList',
            nestedConditionList: [
                {
                    field: 'VariantList.AttributeList',
                    conditionQueryList: [
                        {
                            'field': 'VariantList.AttributeList.Value',
                            'value': '*' + value + '*'
                        }
                    ],
                    conditionTermList: [
                        {
                            'field': 'VariantList.AttributeList.AttributeProperty.Name',
                            'value': 'Przeznaczenie'
                        }
                    ],
                }
            ]
        };

        if (this.request.nestedConditionList === undefined) {
            this.request.nestedConditionList = [];
        }
        this.request.nestedConditionList.push(condition);
    }

    addPhrase(phrase, type) {
        if (phrase != '') {
            if (type == 'ean') {
                var condition = {
                    field: 'VariantList',
                    conditionQueryList: [{
                        field: 'VariantList.EanString',
                        value: phrase + "*"
                    }]
                };

                if (this.request.nestedConditionList === undefined) {
                    this.request.nestedConditionList = [];
                }
                this.request.nestedConditionList.push(condition);
            } else if (type == 'producerCode') {
                let matches = phrase.replace(/[^0-9a-zA-ZĄĆĘŁŃÓŚŻŹąćęłńóśżź]+/g, ' ');

                for(let pr of matches.toLowerCase().split(' ')) {
                    var condition = {
                        field: 'CodeString',
                        value: '*' + pr + '*'
                    };
                    this.addToCondition(condition, 'conditionQueryList');
                }
            } else if (type == 'nameAndDesc') {
                let matches = phrase.replace(/[^0-9a-zA-ZĄĆĘŁŃÓŚŻŹąćęłńóśżź]+/g, ' ');


                for(let pr of matches.toLowerCase().split(' ')) {
                    if (pr.length >= 2) {
                        var conditionOr = {
                            nestedConditionList: [
                                {
                                    field: 'TranslationList',
                                    conditionTermList: [
                                        {'field': 'TranslationList.Value', value: pr}
                                    ]
                                },
                                {
                                    field: 'TranslationList',
                                    conditionQueryList: [{'field': 'TranslationList.ValueString', value: '*' + pr + '*'}]
                                },
                            ]
                        };
                        this.addToCondition(conditionOr, 'conditionORList');
                    }
                }


            } else {
                let matches = phrase.replace(/[^0-9a-zA-ZĄĆĘŁŃÓŚŻŹąćęłńóśżź]+/g, ' ');


                for(let pr of matches.toLowerCase().split(' ')) {
                    if (pr.length >= 2) {
                        var conditionOr = {
                            nestedConditionList: [
                                {
                                    field: 'TranslationList',
                                    conditionTermList: [
                                        {'field': 'TranslationList.Type', 'value': 'n'},
                                        {'field': 'TranslationList.Value', value: pr}
                                    ]
                                },
                                {
                                    field: 'TranslationList',
                                    conditionTermList: [{'field': 'TranslationList.Type', 'value': 'n'}],
                                    conditionQueryList: [{'field': 'TranslationList.ValueString', value: '*' + pr + '*'}]
                                },
                            ]
                        };
                        this.addToCondition(conditionOr, 'conditionORList');
                    }
                }
            }

        }

    }


    addAggregationsProducer(limit) {
        var agg = {
            field: 'Producer.Id',
            name: 'Producer',
            size: limit
        };
        if (!this.request.aggregationList) {
            this.request.aggregationList = [];
        }
        this.request.aggregationList.push(agg);
    }

    addAggregationAttribute(name, aggregationName, limit) {
        var agg = {
            name: name,
            aggregationName: aggregationName,
            nestedName: 'VariantList.AttributeList',
            field: 'VariantList.AttributeList.AttributeProperty.Name',
            size: 30,
            subAggregation: {
                field: 'VariantList.AttributeList.Value',
                name: 'values',
                size: limit,
                countField: 'Id'
            }
        };
        if (!this.request.aggregationList) {
            this.request.aggregationList = [];
        }
        this.request.aggregationList.push(agg);

    }

    addAggregationsCategory(limit) {
        var agg = {
            nestedName: 'CategoryList',
            name: 'Category',
            aggregationName: 'Category',
            field:'CategoryList.Id',
            size: limit
        };
        if (!this.request.aggregationList) {
            this.request.aggregationList = [];
        }
        this.request.aggregationList.push(agg);
    }


    addToCondition(conditionData, conditionType) {
        if (this.request.condition === undefined) {
            this.request.condition = {};
        }
        if (this.request.condition[conditionType] === undefined) {
            this.request.condition[conditionType] = [];
        }
        this.request.condition[conditionType].push(conditionData);
    }

    setSortByNews() {
        this.request.sort = {
            direction: 'desc',
            field: 'VariantList.Added',
            nestedCondition: {
                conditionTermList: [{
                    field: 'VariantList.Active',
                    value: 'y'
                }],
                conditionRangeList: [{
                    field: 'VariantList.StockList.Quantity',
                    from: 0,
                    eqFrom: false
                }]
            }
        };
    }

    setSortByPriceDesc() {
        this.request.sort = {
            direction: 'desc',
            field: 'VariantList.IphPriceList.Price',
            nestedCondition: {
                conditionTermList: [{
                    field: 'VariantList.Active',
                    value: 'y'
                }],
            }
        };
    }

    setSortByPriceAsc() {
        this.request.sort = {
            direction: 'asc',
            field: 'VariantList.IphPriceList.Price',
            nestedCondition: {
                conditionTermList: [{
                    field: 'VariantList.Active',
                    value: 'y'
                }],
            }
        };
    }

    setSortByNameAsc() {
        this.request.sort = {
            direction: 'asc',
            field: 'TranslationList.Value.raw',
            nestedCondition: {
                conditionTermList: [{
                    field: 'TranslationList.Type',
                    value: 'n'
                }],
            }
        };
    }

    setSortByNameDesc() {
        this.request.sort = {
            direction: 'desc',
            field: 'TranslationList.Value.raw',
            nestedCondition: {
                conditionTermList: [{
                    field: 'TranslationList.Type',
                    value: 'n'
                }],
            }
        };
    }

    setSortByQuantityAsc(){
        this.request.sort = {
            direction: 'asc',
            field: 'VariantList.StockList.Quantity',

        };
    }

    setSortByQuantityDesc(){
        this.request.sort = {
            direction: 'desc',
            field: 'VariantList.StockList.Quantity'
        };
    }

    setSortPriority() {
        this.request.sort = {
            direction: 'desc',
            field: 'Priority'
        }
    }

    build() {
        return this.request;
    }

}



//////////////////
// WEBPACK FOOTER
// ./node_modules/redbay-b2b-products/src/search/SearchBuilder.js
// module id = null
// module chunks = 